export const FEEDBACK_SCOPE_QUERY_KEY = "feedback-scope";
export const FEEDBACK_SEGMENT_QUERY_KEY = "feedback-segment";
export const FEEDBACK_PERIOD_QUERY_KEY = "feedback-period";
export const FEEDBACK_START_QUERY_KEY = "feedback-start";
export const FEEDBACK_END_QUERY_KEY = "feedback-end";
export const FEEDBACK_TYPE_QUERY_KEY = "feedback-type";
export const FEEDBACK_SENTIMENT_QUERY_KEY = "feedback-sentiment";
export const FEEDBACK_METRIC_QUERY_KEY = "feedback-metric";

export const FEEDBACK_PERIOD_QUERY_KEYS = [FEEDBACK_PERIOD_QUERY_KEY, FEEDBACK_START_QUERY_KEY, FEEDBACK_END_QUERY_KEY] as const;
export const FEEDBACK_FILTER_QUERY_KEYS = [FEEDBACK_TYPE_QUERY_KEY, FEEDBACK_SENTIMENT_QUERY_KEY, FEEDBACK_METRIC_QUERY_KEY] as const;
